module.exports = __webpack_public_path__ + "static/media/grand_mum_talking_perfect_01.fb60e85b.png";